import {
  hexToHSL,
  adjustLightness,
  adjustSaturation,
  hslToCSS,
  getForegroundFor,
} from "./color-factory";

const FONT_MAP = {
  sans: '"Inter", "Manrope", system-ui, sans-serif',
  serif: '"Playfair Display", Georgia, serif',
  mono: 'Geist Mono, "Fira Code", monospace',
};

export function applyBranding(branding: any) {
  const root = document.documentElement;

  if (!branding) return;

  // --- 1. COLORES (Tu lógica existente) ---
  if (!branding?.primaryColor) {
    root.style.removeProperty("--primary");
    root.style.removeProperty("--primary-foreground");
    root.style.removeProperty("--secondary");
    root.style.removeProperty("--secondary-foreground");
    root.style.removeProperty("--accent");
    root.style.removeProperty("--accent-foreground");
    root.style.removeProperty("--border");
    root.style.removeProperty("--dark-primary");
    root.style.removeProperty("--dark-primary-foreground");
    root.style.removeProperty("--dark-secondary");
    root.style.removeProperty("--dark-secondary-foreground");
  } else {
    const primary = hexToHSL(branding.primaryColor);
    const secondary = hexToHSL(branding.secondaryColor || "#1e293b");

    // LIGHT THEME
    root.style.setProperty("--primary", hslToCSS(primary));
    root.style.setProperty("--primary-foreground", getForegroundFor(primary));

    root.style.setProperty("--secondary", hslToCSS(secondary));
    root.style.setProperty(
      "--secondary-foreground",
      getForegroundFor(secondary),
    );

    // Derived
    const accent = adjustLightness(primary, +20);
    root.style.setProperty("--accent", hslToCSS(accent));
    root.style.setProperty("--accent-foreground", getForegroundFor(accent));

    const border = adjustSaturation(adjustLightness(primary, -30), -20);
    root.style.setProperty("--border", hslToCSS(border));

    // DARK THEME
    const darkPrimary = adjustLightness(primary, +20);
    const darkSecondary = adjustLightness(secondary, -20);

    root.style.setProperty("--dark-primary", hslToCSS(darkPrimary));
    root.style.setProperty(
      "--dark-primary-foreground",
      getForegroundFor(darkPrimary),
    );

    root.style.setProperty("--dark-secondary", hslToCSS(darkSecondary));
    root.style.setProperty(
      "--dark-secondary-foreground",
      getForegroundFor(darkSecondary),
    );
  }

  // --- 2. TIPOGRAFÍA ---
  if (branding.fontFamily) {
    const fontStack =
      FONT_MAP[branding.fontFamily as keyof typeof FONT_MAP] || FONT_MAP.sans;
    // Inyectamos la variable para que @theme la use si es necesario
    root.style.setProperty("--brand-font", fontStack);
    // Aplicamos al body directamente para que herede todo
    //document.body.style.fontFamily = fontStack;
    // IMPORTANTE: Aplicar al root para que Tailwind/CSS lo herede mediante variables
    root.style.fontFamily = fontStack;
  } else {
    root.style.setProperty("--brand-font", FONT_MAP.sans);
    root.style.fontFamily = FONT_MAP.sans;
  }

  // --- 3. REDONDEADO (Border Radius) ---
  const rawRadius = branding.borderRadius ?? branding.radius;
  const radiusValue =
    rawRadius !== undefined && rawRadius !== null
      ? parseInt(rawRadius.toString(), 10)
      : 8;

  if (!isNaN(radiusValue)) {
    const r = `${radiusValue}px`;
    root.style.setProperty("--radius", r);
    root.style.setProperty("--brand-radius", r);
  } else {
    root.style.setProperty("--radius", "8px");
    root.style.setProperty("--brand-radius", "8px");
  }

  if (branding.faviconUrl) {
    let link: HTMLLinkElement | null =
      document.querySelector("link[rel~='icon']");
    if (!link) {
      link = document.createElement("link");
      link.rel = "icon";
      document.getElementsByTagName("head")[0].appendChild(link);
    }
    link.href = branding.faviconUrl;
  }
}
